<template>
  <nav class="side-nav">
    <div class="panel-info">
      <h3 class="user-company">{{ userInfos.company }}</h3>
      <div class="name">
        {{ userInfos.first_name + " " + userInfos.last_name }}
      </div>
      <span> {{ userInfos.email }}</span>
      <span> {{ userInfos.phone_number }}</span>
      <button class="logout-button" @click="logout">Déconnexion</button>
    </div>
    <div v-if="userInfos.id_role == 1" class="card admin-nav">
      <div class="headline">Menu</div>
      <div @click="go_to_info" class="btn btn-info btn-sm">
        <i class="fas fa-home mr-2"></i>Accueil
      </div>
      <div @click="go_to_admin" class="btn btn-info btn-sm mt-3">
        <i class="fas fa-users mr-2"></i>Admin
      </div>
    </div>
    <div class="contact card">
      <div class="headline">Contactez AgriVitech</div>
      <!-- <a
        href="https://bazam.atlassian.net/servicedesk/customer/portal/2"
        class="btn btn-primary btn-sm mb-3"
        target="blank"
        ><i class="fas fa-bug mr-2"></i> Ouvrir un ticket</a
      > -->
      <router-link class="btn btn-primary btn-sm" to="/contact"
        ><i class="fas fa-envelope-open mr-2"></i> Formulaire de
        contact</router-link
      >
      <!-- <router-link class="btn btn-primary btn-sm mt-3" to="/contact-demo"
        ><i class="fas fa-calendar-plus mr-2"></i> Réservez une
        visio</router-link
      > -->
      <a
        href="https://discord.gg/t5GE2wTDSk"
        class="btn btn-primary btn-sm mt-3"
        target="blank"
        ><i class="fab fa-discord mr-2"></i> Rejoignez notre Discord</a
      >
    </div>
  </nav>
</template>
<script>
import { useRouter } from "vue-router";
export default {
  props: ["userInfos"],
  setup() {
    const router = useRouter();
    const logout = () => {
      localStorage.removeItem("token");
      router.push("/private");
    };

    const go_to_admin = () => {
      router.push("/private/admin");
    };

    const go_to_info = () => {
      router.push("/private/me");
    };

    return {
      go_to_admin,
      logout,
      go_to_info,
    };
  },
};
</script>


<style lang="scss" scoped>
.side-nav {
  margin-right: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  .panel-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    border-radius: 5px;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
    padding: 1em;
    margin-bottom: 1em;
    .name{
      font-weight: 700;
      font-size: 17px;
      margin-bottom: 0.5rem;
    }
    .user-company {
      font-weight: bolder;
      text-transform: capitalize;
    }
    .logout-button {
      color: white;
      width: 100%;
      padding: 1em;
      margin-top: 1em;
      background-color: var(--mainBlue);
      border: none;
      font-size: 1em;
      font-weight: bolder;
      text-transform: uppercase;
      transition: all 0.2s ease;
    }
    .logout-button:hover {
      color: var(--mainGreen);
    }
  }
  .contact, .admin-nav {
    padding: 1em;
    margin-bottom: 1rem;
    border-radius: 5px;
    // box-shadow: 1px 1px 5px rgba($color: #000000, $alpha: 0.3);
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
    .headline {
      font-weight: 700;
      font-size: 17px;
      margin-bottom: 1rem;
    }
  }
  .card {
    border: none;
    background-color: rgba($color: #000000, $alpha: 0);
    .btn {
      box-shadow: none;
      border-radius: 5px!important;
    }
  }
}
</style>